import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const RequestService = {
    create: async (model) => axios.post(API_URL + "/requests", model).then(({data}) => data).catch(err => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/requests/" + id, model).then(({data}) => data).catch(err => { throw err }),
    delete: async (id) => axios.delete(API_URL + "/requests/" + id).then(({data}) => data).catch(err => { throw err }),
    list: async (filters) => axios.post(API_URL + "/requests/list", filters).then(({data}) => data).catch(err => { throw err }),
    getById: async (id) => axios.get(API_URL + "/requests/" + id).then(({data}) => data).catch((err) => { throw err }),
    getAssociatedRequests: async (id) => axios.get(API_URL + "/associatedRequests/" + id).then(({data}) => data).catch((err) => { throw err }),
    getRequestsIds: async () => axios.get(API_URL + "/requests/ids" ).then(({data}) => data).catch((err) => { throw err }),
    deleteAssociatedRequest: async (id) => axios.delete(API_URL + "/associatedRequests/" + id).then(({data}) => data).catch(err => { throw err }),
}

export default RequestService;